module.exports = __webpack_public_path__ + "images/general_banner01@3x.png";